export default __webpack_public_path__ + "static/media/c.e74dce8d.png";